export enum TableViewEnum {
  TABLE,
  CARD
}
